import { useCallback, useEffect, useMemo, useState } from "react";
import { useContractRead } from "wagmi";
import { commify, formatEther } from "ethers/lib/utils";

// Config
import { config } from "config/network";
import { vaultsConfig } from "config/vaults";

// Constants
import { vaults } from "constants/vaults";
import { BigNumber } from "ethers";

// Services
import { getVaultsData } from "services/vaults";

// Hooks
import useConverstionRates from "./useConverstionRates";

const useVaults = () => {
  const [vaultInfo, setVaultInfo] = useState<any>({});

  const { conversionToBnb } = useConverstionRates();

  // use useContractReads when there are multiple contracts
  const { data: vault1Data, refetch: vault1Refetch } = useContractRead({
    address: vaultsConfig[vaults[0].key].address,
    abi: vaultsConfig[vaults[0].key].abi,
    functionName: "totalInLP",
    chainId: +config.chainId,
    structuralSharing: true,
  });

  useEffect(() => {
    (async function fetchData() {
      const response = await getVaultsData();

      setVaultInfo(response);
    })();
  }, []);

  const refectch = useCallback(() => {
    vault1Refetch();
  }, [vault1Refetch]);

  const data = useMemo(
    () =>
      vaults.reduce(
        (acc, curr) => ({
          ...acc,
          [curr.key]: {
            apy: vaultInfo[curr.key]?.apy,
            tvl: commify(
              +parseFloat(
                (
                  +formatEther(
                    BigNumber.from(vault1Data ? vault1Data.toString() : "0")
                  ) * conversionToBnb
                ).toString()
              ).toFixed(4) || "0"
            ),
          },
        }),
        {}
      ),
    [vault1Data, vaultInfo, conversionToBnb]
  );

  return {
    totalTVL: +parseFloat(
      (
        +formatEther(BigNumber.from(vault1Data ? vault1Data.toString() : "0")) *
        conversionToBnb
      ).toString()
    ).toFixed(4),
    vaults: data,
    apyInfo: vaultInfo,
    refectch,
  };
};

export default useVaults;
